export default "__VITE_ASSET__DRgE4d2B__"